module.exports = __webpack_public_path__ + "img/Angiogenesis-PRCA_SpatialResearch.e7e564fa.png";